module.exports = __webpack_public_path__ + "static/media/CTLI_5-111w.8934a3e2.webp";